export default "__VITE_ASSET__Ck7a5aMT__"